<template>
  <app-card :status="competition.status" class="flex flex-col">
    <div class="flex flex-col h-full mb-4 p-4">
      <div class="flex mb-6 border-b pb-4 items-start">
        <div class="flex-1">
          <h3>
            {{ competition.title }}
          </h3>
          <p v-if="competition.funding_pots[0]" class="text-xs text-grey-600">
            {{ competition.funding_pots[0].name }}
          </p>
        </div>
        <card-actions>
          <ul class="list-reset text-sm text-center">
            <li class="p-2">
              <a
                class="block no-underline hover:text-primary-800 text-black"
                :href="route('competitions.applications', competition.uuid)"
              >
                Applications
              </a>
            </li>
            <li class="p-2">
              <a
                class="block no-underline hover:text-primary-800 text-black"
                :href="route('competitions.grading', competition.uuid)"
              >
                Grading
              </a>
            </li>
            <li class="p-2 border-t border-grey-200">
              <a
                class="block no-underline hover:text-primary-800 text-black"
                target="_blank"
                :href="route('competitions.edit', competition.uuid)"
              >
                Edit
              </a>
            </li>
            <li class="p-2 border-t border-grey-200">
              <a
                class="block no-underline hover:text-primary-800 text-black"
                target="_blank"
                :href="
                  route('competitions.edit', competition.uuid) + '#assessors'
                "
              >
                Assessors
              </a>
            </li>
          </ul>
        </card-actions>
      </div>
      <ul class="list-reset flex  text-center">
        <li class="w-1/3 py-2 border-r">
          <h4 class="text-2xs tracking-wide uppercase text-grey-600 mb-2">
            Downloads
          </h4>
          <p class="text-2xl sm:text-4xl text-primary-700 leading-none">
            {{ competition.guidance_pack_download_count }}
          </p>
        </li>
        <li class="w-1/3 py-2 pl-4 pr-4 border-r">
          <h4 class="text-2xs tracking-wide uppercase text-grey-600 mb-2">
            In Progress
          </h4>
          <p class="text-2xl sm:text-4xl text-primary-700 leading-none">
            {{ competition.applications_in_progress.length }}
          </p>
        </li>
        <li class="w-1/3 py-2 pl-4">
          <h4 class="text-2xs tracking-wide uppercase text-grey-600 mb-2">
            Completed
          </h4>
          <p class="text-2xl sm:text-4xl text-primary-700 leading-none">
            {{ competition.applications_completed.length }}
          </p>
        </li>
      </ul>
    </div>
    <div class="border-t bg-grey-100 p-4 flex">
      Progress
    </div>
  </app-card>
</template>

<script>
import parseISO from "date-fns/parseISO";
export default {
  name: "AdminCompetitionCard",
  props: {
    competition: {
      type: Object,
      required: true
    }
  },
  methods: {
    parse(date) {
      return parseISO(date);
    }
  }
};
</script>

<style></style>
